<template>
  <div :class="device" class="ecs">
    <emat-loader v-if="loading" :loading="loading" :global="true"></emat-loader>
    <welcome-modal @next="next" v-if="openModal && !loading"></welcome-modal>
    <charging-container v-if="!loading" @previous="previous"></charging-container>
  </div>
</template>

<script>
import verge from "verge";
import { mapActions, mapState } from "vuex";
import ChargingContainer from "./components/ChargingContainer";
import Welcome from "./components/modal/Welcome";
import EmatLoader from 'Components/General/Loader';

export default {
  name: 'App',
  components: {
    ChargingContainer,
    'welcome-modal': Welcome,
    EmatLoader
  },
  data() {
    return {
      openModal: true,
      loading: false,
    }
  },

  methods: {
    ...mapActions('build', [
      'fetchBuild',
    ]),

    next(arg) {
      this.openModal = false;
      this.$store.dispatch('setSelection', arg);
    },
    previous() {
      this.openModal = true;
    },
    setResponsiveDevice() {
      const width = verge.viewportW();
      let device;
      if (width > 1024) {
        device = 'desktop';
      } else if (width > 840) {
        device = 'tablet';
      } else if (width < 840) {
        device = 'mobile';
      }
      this.$store.dispatch('setDevice', device);
    },
  },

  computed: {
    ...mapState({
      buildId: state => state.buildId
    }),

    device() {
      return this.$store.getters.getDevice;
    }
  },

  async mounted() {
    this.loading = true;
    await this.$store.dispatch('initialize');
    await this.$store.dispatch('build/initialize');

    if (this.buildId) {
      await this.fetchBuild(this.buildId);
      this.openModal = false;
    }

    this.loading = false;
  },

  created() {
    window.addEventListener("resize", this.setResponsiveDevice);

    this.setResponsiveDevice();
  },
}
</script>

<style lang="scss">
.ecs {
  background-color: $background-color;
}

.columns .column.main {
  padding-bottom: 0 !important;
}

.page-main {
  margin-top: 0 !important;
}

@media (max-width: 1000px) {
 @media only screen and (max-width: 840px) {
    body > .page-wrapper {
      max-height: 100vh;
      overflow: hidden;
    }
  }
}

#app {
  font-family: 'Antenna', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #f9f9f9;
  min-height: 100vh;

  &.mobile {
    padding-top: 86px;
    padding-bottom: 34px;
    height: 100vh;
    max-width: 100vw;
    box-sizing: border-box;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }
}

.select[name=car-brands] {
  width: 100% !important;
  max-width: 100% !important;
}

</style>
